import axios from 'axios';
import { fnBrowserDetect } from './browserDetect';
import { getBaseUrl } from './launchStrategies/helpers';

const apiErrorPath = '/rqx/obs/errors';

function errorBuilder(
  error: any,
  code: string,
  name: string,
  description: string,
) {
  return {
    code,
    name,
    description,
    location: window.location.href,
    dump: JSON.stringify(error),
    browser: fnBrowserDetect(),
    app: 'appshell',
  };
}

export async function errorGenerator(
  code: string,
  error: any = {},
  name = '',
  description = '',
) {
  const apiBaseUrl = getBaseUrl();
  const data = errorBuilder(error, code, name, description);
  await axios.post(`${apiBaseUrl}${apiErrorPath}`, {
    data,
  });
}
